import './admin-page.css';
import { Header } from '../header/header';
import { Menu } from 'antd';
import { useState } from 'react';
import type { MenuProps } from 'antd';
import { ScriptPage } from '../script-editor/script-page';
import { AdminCustomerRule } from './components/customer-rule/customer-rule';
import AdminSnoozeConfig from './components/snooze-config/admin-snooze-config';
import AdminTranscription from './components/transcription/admin-transcription';
import { AdminAchievements } from './components/live-reporting-config/achievements';
import { AdminExperience } from './components/live-reporting-config/experience-points';
import { EditContactContainer } from './components/edit-contacts/edit-contacts';
import { PowerHourConfigContainter } from './components/power-hour-config/power-hour-config';
import { AdminBookerLeague } from './components/booker-leagues/admin-booker-leagues';
import { AdminSlotConfig } from './components/slot-config/admin-slot-config';
import AdminAutodialConfig from './components/autodial-config/admin-autodial-config';
type MenuItem = Required<MenuProps>['items'][number];

export const AdminPage = () => {
  const [selectedKey, setSelectedKey] = useState<string>('1');

  const items: MenuItem[] = [
    { key: 1, label: 'Customer Rules' },
    { key: 2, label: 'Snooze Config' },
    { key: 3, label: 'Appointment Limit' },
    { key: 4, label: 'Scripts' },
    { key: 5, label: 'Transcription' },
    { key: 6, label: 'Booker Leagues' },
    { key: 7, label: 'Experience Points' },
    { key: 8, label: 'Achievements' },
    { key: 9, label: 'Edit Contacts' },
    { key: 10, label: 'Power Hour Config' },
    { key: 11, label: 'Autodialer CLI Number Config' },
  ];

  return (
    <>
      <Header />
      <div className="flex-admin-container">
        <Menu defaultSelectedKeys={['1']} mode="inline" style={{ width: '11%' }} onSelect={(item) => setSelectedKey(item.key.toString())} items={items} />
        {selectedKey === '1' && <AdminCustomerRule />}
        {selectedKey === '2' && <AdminSnoozeConfig />}
        {selectedKey === '3' && <AdminSlotConfig />}
        {selectedKey === '4' && <ScriptPage />}
        {selectedKey === '5' && <AdminTranscription />}
        {selectedKey === '6' && <AdminBookerLeague />}
        {selectedKey === '7' && <AdminExperience />}
        {selectedKey === '8' && <AdminAchievements />}
        {selectedKey === '9' && <EditContactContainer />}
        {selectedKey === '10' && <PowerHourConfigContainter />}
        {selectedKey === '11' && <AdminAutodialConfig />}
      </div>
    </>
  );
};
